<div class="mx-auto mt-5 gap-3 md:container md:flex" *ngIf="user.name">
  <div class="hidden w-[300px] text-primary-darkest md:block">
    <div
      class="mb-5 rounded-md bg-primary-lightest p-4 shadow-md"
      *ngIf="user.is_email_verified == 0">
      <div class="mb-1 text-lg font-bold">Verify Your Email</div>
      <p class="mb-3 text-sm">
        Hi, please use the button to verify your email and start enjoying
        Beautybook
      </p>
      <button
        type="button"
        class="w-full rounded-md bg-primary-md-dark p-1 text-center text-white duration-200 ease-in-out"
        [ngClass]="{
          'cursor-not-allowed opacity-50': verifyLoading,
          'hover:bg-primary-darkest': !verifyLoading
        }"
        (click)="verifyEmail()">
        Verify Email
        <fa-icon
          *ngIf="verifyLoading"
          class="ml-3"
          [icon]="faSpinner"
          [spin]="true"></fa-icon>
      </button>
    </div>
    <div class="rounded-md border py-6 shadow-md">
      <div class="mb-4 flex items-center space-x-3 px-4">
        <picture class="flex-none">
          <img
            class="h-11 w-11 rounded-full border border-primary-md-dark object-center"
            [src]="user.propic_path || 'assets/images/default-user.png'"
            alt="profile image" />
        </picture>
        <div class="truncate font-bold">{{ user.name }}</div>
      </div>
      <div
        class="relative mx-4 overflow-hidden rounded-lg bg-primary-md-dark px-3 py-4">
        <picture class="absolute top-0 left-0 h-full">
          <img
            class="h-full w-full object-cover object-center"
            src="assets/images/happy-pay/bg-happy-pay-card-sm.png"
            alt="" />
        </picture>
        <div class="relative">
          <div class="flex items-center space-x-3">
            <picture class="h-10 w-10 flex-none rounded-full bg-white p-2">
              <img
                class=""
                src="assets/images/logo-sm.png"
                alt="happy beuty logo" />
            </picture>
            <div class="truncate text-white">
              <span class="block font-bold">Happy Pay</span>
              <span class="block truncate text-sm font-medium"
                >Acc. No: {{ user.happy_pay.account_no }}</span
              >
            </div>
          </div>
          <div class="mt-4">
            <div class="mb-3 text-right font-bold text-white">
              {{ user.happy_pay.current_balance | fcCurrency }}
            </div>
            <button
              type="button"
              class="flex w-full justify-center rounded-md bg-white p-1 text-center text-primary-md-dark duration-200 ease-in-out hover:bg-slate-50">
              <fa-icon class="mr-2" [icon]="faSquarePlus"></fa-icon>
              Top Up
            </button>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <h1 class="mb-2 px-6 font-medium uppercase text-primary-md-dark">
          My Info
        </h1>
        <ul class="font-medium text-primary-darkest/60">
          <li>
            <a
              routerLink="/user/profile"
              routerLinkActive="text-primary-md-dark bg-primary-lightest [&>.indicator]:block"
              class="relative flex items-center px-6 py-3 hover:bg-primary-lightest hover:text-primary-darkest">
              <fa-icon class="basis-8" [icon]="faUser"></fa-icon>
              <div>My Profile</div>
              <span
                class="indicator absolute top-0 right-0 hidden h-full w-1 bg-primary-md-dark"></span>
            </a>
          </li>
          <li>
            <a
              routerLink="/user/dashboard"
              routerLinkActive="text-primary-md-dark bg-primary-lightest [&>.indicator]:block"
              class="relative flex items-center px-6 py-3 hover:bg-primary-lightest hover:text-primary-darkest">
              <fa-icon class="basis-8" [icon]="faGauge"></fa-icon>
              <div>Dashboard</div>
              <span
                class="indicator absolute top-0 right-0 hidden h-full w-1 bg-primary-md-dark"></span
            ></a>
          </li>
        </ul>
        <h2 class="mb-2 mt-5 px-6 font-medium uppercase text-primary-md-dark">
          transactions
        </h2>
        <ul class="font-medium text-primary-darkest/60">
          <li>
            <a
              routerLink="/user/checkout"
              routerLinkActive="text-primary-md-dark bg-primary-lightest [&>.indicator]:block"
              class="relative flex items-center px-6 py-3 hover:bg-primary-lightest hover:text-primary-darkest">
              <fa-icon class="basis-8" [icon]="faMoneyCheckDollar"></fa-icon>
              <div>Checkout</div>
              <span
                class="indicator absolute top-0 right-0 hidden h-full w-1 bg-primary-md-dark"></span>
            </a>
          </li>
          <li>
            <a
              routerLink="/user/order"
              routerLinkActive="text-primary-md-dark bg-primary-lightest [&>.indicator]:block"
              class="relative flex items-center px-6 py-3 hover:bg-primary-lightest hover:text-primary-darkest">
              <fa-icon class="basis-8" [icon]="faBagShopping"></fa-icon>
              <div>My Orders</div>
              <span
                class="indicator absolute top-0 right-0 hidden h-full w-1 bg-primary-md-dark"></span>
            </a>
          </li>
          <li>
            <a
              routerLink="/user/happy-pay"
              routerLinkActive="text-primary-md-dark bg-primary-lightest [&>.indicator]:block"
              class="relative flex items-center px-6 py-3 hover:bg-primary-lightest hover:text-primary-darkest">
              <fa-icon class="basis-8" [icon]="faCoins"></fa-icon>
              <div>Happy Pay</div>
              <span
                class="indicator absolute top-0 right-0 hidden h-full w-1 bg-primary-md-dark"></span>
            </a>
          </li>
        </ul>
        <h3 class="mb-2 mt-7 px-6 font-medium uppercase text-primary-md-dark">
          OTHERS
        </h3>
        <ul class="font-medium text-primary-darkest/60">
          <li>
            <a
              routerLink="/user/review"
              routerLinkActive="text-primary-md-dark bg-primary-lightest [&>.indicator]:block"
              class="relative flex items-center px-6 py-3 hover:bg-primary-lightest hover:text-primary-darkest">
              <fa-icon class="basis-8" [icon]="faMessage"></fa-icon>
              <div class="mb-1">Reviews</div>
              <span
                class="indicator absolute top-0 right-0 hidden h-full w-1 bg-primary-md-dark"></span>
            </a>
          </li>
          <li>
            <a
              routerLink="/user/beautybook-post"
              routerLinkActive="text-primary-md-dark bg-primary-lightest [&>.indicator]:block"
              class="relative flex items-center px-6 py-3 hover:bg-primary-lightest hover:text-primary-darkest">
              <fa-icon class="basis-8" [icon]="faWandMagicSparkles"></fa-icon>
              <div>My Beautybook Posts</div>
              <span
                class="indicator absolute top-0 right-0 hidden h-full w-1 bg-primary-md-dark"></span>
            </a>
          </li>
          <li>
            <a
              routerLink="/user/wishlist"
              routerLinkActive="text-primary-md-dark bg-primary-lightest [&>.indicator]:block"
              class="relative flex items-center px-6 py-3 hover:bg-primary-lightest hover:text-primary-darkest">
              <fa-icon class="basis-8" [icon]="faHeart"></fa-icon>
              <span> Wishlist</span>
              <span
                class="indicator absolute top-0 right-0 hidden h-full w-1 bg-primary-md-dark"></span
            ></a>
          </li>
          <li>
            <a
              routerLink=""
              class="flex items-center px-6 py-3 hover:bg-primary-lightest hover:text-primary-darkest">
              <fa-icon class="basis-8" [icon]="faRightFromBracket"></fa-icon>
              <span> Logout</span></a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="px-3 md:flex-1 lg:px-0 lg:pl-7">
    <router-outlet></router-outlet>
  </div>
</div>
